module.exports = __webpack_public_path__ + "img/ytdx.c19e8385.png";